export const JobTypes = {
  Contract: 1,
  DirectHire: 2,
  PartTime: 3,
  SourceAndScreen: 4,
  Sourcing: 5
}
export const currencySymbol = '₹'
export const messageEditAllowedMinutes = 30

export const paddingHorizontal = '72px'
export const paddingVertical = '40px'

export const ChatOperationCodes = {
  newMessage: 1,
  messageUpdated: 2,
  messageDeleted: 3
}
